<template>
  <div class="wrapper">
    <inner-list
      :loading="loading"
      :results="results"
      :pagination="pagination"
      @editInstance="openModal"
      @deleteInstance="handleDelete"
    />
    <a-button type="primary" icon="plus" @click="openModal">
      Dodaj aplikacje
    </a-button>
    <application-modal ref="applicationModal" @formSubmitted="fetchData" />
  </div>
</template>
<script>
import InnerList from './InnerList'
import { Application } from '@/api'
import PaginatedList from '@/components/layout/PaginatedList'
import ApplicationModal from '@/components/modals/ApplicationModal'

export default {
  extends: PaginatedList,
  components: {
    InnerList,
    ApplicationModal
  },
  methods: {
    openModal({ instanceId }) {
      this.$refs.applicationModal.openModal({
        instanceId,
        lecturerId: this.$route.params.lecturerId,
        studentId: this.$route.params.studentId
      })
    },
    handleDelete(instanceId) {
      this.deleteInstance(
        instanceId,
        {
          title: 'Usuń aplikację',
          text: 'Czy napewno chcesz usunąć tę aplikację?'
        },
        'Aplikacja usunięta'
      )
    }
  },
  data() {
    return {
      service: Application
    }
  },
  computed: {
    params() {
      const user = this.$route.params.lecturerId || this.$route.params.studentId
      return {
        ...this.$route.query,
        user
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
